import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Clock } from 'lucide-react';

export const CTASection = ({ onContactClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-800 via-emerald-700 to-emerald-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center bg-amber-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-8">
            <Clock className="h-4 w-4 mr-2" />
            Limited Time: Fast-Track Processing Available
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Protect Your Brand Today
          </h2>
          
          <p className="text-xl md:text-2xl text-emerald-100 mb-8 leading-relaxed">
            Don't wait until someone copies your brand. Federal trademark registration is the best investment you can make to secure your business identity and prevent costly disputes.
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8 border border-emerald-600">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div>
                <div className="text-4xl font-bold text-amber-400 mb-2">$45</div>
                <div className="text-emerald-100">Starting Price</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-amber-400 mb-2">24 Hrs</div>
                <div className="text-emerald-100">Processing Time</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-amber-400 mb-2">98%</div>
                <div className="text-emerald-100">Success Rate</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onContactClick}
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white font-bold px-12 py-8 text-xl transition-all duration-300 shadow-2xl hover:shadow-3xl hover:-translate-y-1"
            >
              Register My Trademark
              <ArrowRight className="ml-3 h-6 w-6" />
            </Button>
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="border-3 border-white text-white hover:bg-white hover:text-emerald-800 font-bold px-12 py-8 text-xl transition-all duration-300"
            >
              Free Consultation
            </Button>
          </div>

          <p className="mt-8 text-emerald-200 text-sm">
            ✓ No obligation consultation  ✓ Transparent pricing  ✓ Expert guidance
          </p>
        </div>
      </div>
    </section>
  );
};
